
define('template!trackingDetailTabTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="well mbamodel-detail">\n  <div class="detailed-info-form-container">\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('tracking.destination') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( destinationType ? destinationType : 'tocustomer' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('tracking.carrier') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( carrier ? carrier : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n        <div class="col-xs-4">' +
((__t = ( _.i18n('tracking.trackingNumber') )) == null ? '' : __t) +
'</div>\n        <div class="col-xs-8">' +
((__t = ( trackingNumber ? trackingNumber : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-6">\n          <div class="col-xs-4">' +
((__t = ( _.i18n('tracking.trackingStatus') )) == null ? '' : __t) +
'</div>\n          <div class="col-xs-8">' +
((__t = ( trackingStatus ? trackingStatus : '-' )) == null ? '' : __t) +
'</div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="pull-right p-r-15">\n        <button class="btn btn-primary js-edit">' +
((__t = ( _.i18n('common.edit') )) == null ? '' : __t) +
'</button>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

